import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../../Avatar';
import Link from '../../Link';

import { readMessage } from '../../../actions/message/readMessage';

import s from '../Inbox.css';

const InboxItem = ({
  type,
  threadId,
  profileId,
  picture,
  displayName,
  content,
  createdAt,
  startDate,
  endDate,
  city,
  state,
  country,
  status,
  read
}) => {
  const dispatch = useDispatch();

  const handleReadMessage = () => {
    dispatch(readMessage(threadId, type));
  };

  const createdDate = createdAt ? moment(parseInt(createdAt)).format('MM/DD/YYYY') : '';
  const start = startDate ? `(${moment(startDate).format('MM/DD/YYYY')}` : '';
  const end = endDate ? ` - ${moment(endDate).format('MM/DD/YYYY')})` : '';

  return (
    <li className={s.PanelBody}>
      <div className={s.listAvatarGrid}>
        <div>
          <Avatar
            source={picture}
            height={83}
            width={83}
            title={displayName}
            className={s.profileAvatar}
            withLink
            linkClassName={s.profileAvatarLink}
            profileId={profileId}
          />
        </div>
        <div className={cx(s.listDeatilsGrid, 'listingTagCurve grayBgCurve')}>
          <div className={s.inboxAvaterWidth}>
            <p className={s.dislayNameText}>{displayName}</p>
            <time className={s.dislayNameText}>{createdDate}</time>
          </div>
          <div>
            <Link to={`/message/${threadId}/${type}`} className={cx(s.textMuted)} onClick={handleReadMessage}>
              <p className={cx(s.contentText)}>{content}</p>
              <p className={cx(s.cityText)}>
                {city}, {state}, {country} {start} {end}
              </p>
            </Link>
          </div>
          <div className={cx('messageStatus')}>{status}</div>
        </div>
      </div>
    </li>
  );
};

InboxItem.propTypes = {
  type: PropTypes.string.isRequired,
  status: PropTypes.string,
  threadId: PropTypes.number.isRequired,
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  content: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  sentBy: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  read: PropTypes.bool.isRequired
};

InboxItem.defaultProps = {
  createdAt: null,
  startDate: null,
  endDate: null,
  picture: null,
  status: null,
  sentBy: null,
  read: false
};

export default withStyles(s)(InboxItem);